export default __webpack_public_path__ + "static/media/rgs_small@2x.7102507f.jpg";